import React from "react";
import { useEffect } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Portfolio from "./Portfolio";

function App() {
  useEffect(() => {
    const fingerprint = btoa(
      navigator.userAgent + navigator.language + window.screen.width,
    );

    fetch("https://port-front-flame.vercel.app/visit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fingerprint }),
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
